"use strict";
import { atom } from "jotai";
import { useAtomValue, useUpdateAtom } from "jotai/utils";
import { Switch } from "ui/src";
import { useEvent } from "utilities/src/react/hooks";
const oneClickSwapAtom = atom(true);
const overrideOneClickSwapFlagAtom = atom(false);
export function useResetOverrideOneClickSwapFlag() {
  const setOverrideOneClickSwapFlag = useUpdateAtom(overrideOneClickSwapFlagAtom);
  return useEvent(() => setOverrideOneClickSwapFlag(false));
}
export function useSetOverrideOneClickSwapFlag() {
  const setOverrideOneClickSwapFlag = useUpdateAtom(overrideOneClickSwapFlagAtom);
  return useEvent(() => setOverrideOneClickSwapFlag(true));
}
export function useOneClickSwapSetting() {
  const isOneClickSwapEnabled = useAtomValue(oneClickSwapAtom);
  const overrideOneClickSwap = useAtomValue(overrideOneClickSwapFlagAtom);
  const updateOneClickSwapEnabled = useUpdateAtom(oneClickSwapAtom);
  const resetOverrideOneClickSwapFlag = useResetOverrideOneClickSwapFlag();
  const enabled = isOneClickSwapEnabled && !overrideOneClickSwap;
  const toggle = useEvent((value) => {
    updateOneClickSwapEnabled(value);
    if (value) {
      resetOverrideOneClickSwapFlag();
    }
  });
  return { enabled, toggle };
}
export const OneClickSwap = {
  renderTitle: (t) => t("swap.settings.oneClickSwap.title"),
  renderTooltip: (t) => t("swap.settings.oneClickSwap.tooltip"),
  Control() {
    const oneClickSwapSetting = useOneClickSwapSetting();
    return <Switch checked={oneClickSwapSetting.enabled} variant="branded" onCheckedChange={oneClickSwapSetting.toggle} />;
  }
};
